import React from "react";
import { Phone, MessageCircle, Upload } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";

export const FloatingBar = () => {
  const { lang, tr } = useLang();
  const { business, waLink } = useContent();
  const kn = lang === "kn";

  return (
    <div data-testid="floating-bar" className="fixed bottom-0 inset-x-0 z-40 lg:hidden">
      <div className="grid grid-cols-3 border-t border-slate-200 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <a href={`tel:${business.phone}`} data-testid="float-call" className="flex flex-col items-center justify-center gap-1 py-2.5 text-slate-700 active:bg-slate-50">
          <Phone size={20} className="text-primary" />
          <span className={`text-[11px] font-bold ${kn ? "font-kn" : ""}`}>{tr("call")}</span>
        </a>
        <a href={waLink("Hi Creative Prints!")} target="_blank" rel="noreferrer" data-testid="float-whatsapp" className="flex flex-col items-center justify-center gap-1 py-2.5 text-white bg-[#25D366] active:bg-[#1da851]">
          <MessageCircle size={20} />
          <span className={`text-[11px] font-bold ${kn ? "font-kn" : ""}`}>{tr("whatsapp")}</span>
        </a>
        <a href="#quote" data-testid="float-quote" className="flex flex-col items-center justify-center gap-1 py-2.5 text-white bg-primary active:bg-amber-700">
          <Upload size={20} />
          <span className={`text-[11px] font-bold ${kn ? "font-kn" : ""}`}>{tr("upload_quote")}</span>
        </a>
      </div>
    </div>
  );
};

export const WhatsAppFab = () => {
  const { waLink } = useContent();
  return (
    <a
      href={waLink("Hi Creative Prints, I want a quote.")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      className="hidden lg:flex fixed bottom-6 right-6 z-40 h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-600/30 hover:scale-110 transition-transform"
      aria-label="WhatsApp"
    >
      <MessageCircle size={26} />
    </a>
  );
};
